// constants/actions.ts
export const ACTIONS = Object.freeze({
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    AI_UPLOAD: 'AI_UPLOAD',
    AI_SUMMARY: 'AI_SUMMARY',
    PPT_EXPORT: 'PPT_EXPORT',
    EXCEL_EXPORT: 'EXCEL_EXPORT',
    JSON_EXPORT: 'JSON_EXPORT',
    PUBMED_SEARCH: 'PUBMED_SEARCH',
    PUBMED_EVIDENCE_IMPORT: 'PUBMED_EVIDENCE_IMPORT',
    SNAPSHOT: 'SNAPSHOT',
    MAIA_CHAT: 'MAIA_CHAT',
    MAIA_RESPONSE_RECEIVED: 'MAIA_RESPONSE_RECEIVED',
    MAIA_TASK_FAILED: 'MAIA_TASK_FAILED',
    MAIA_SEND_ERROR: 'MAIA_SEND_ERROR',
    MAIA_NOT_FOUND: 'MAIA_NOT_FOUND',
    MAIA_EXAMPLE_SELECT: 'MAIA_EXAMPLE_SELECT',
    MAIA_TOPIC_RUN: 'MAIA_TOPIC_RUN',
    MAIA_DELETE: 'MAIA_DELETE',
    READ: 'READ',
    DELETE: 'DELETE',
    UNIMPORT: 'UNIMPORT',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    VIEW: 'VIEW',
    TRANSFER: 'TRANSFER',
    CHANGE_ROADMAP: 'CHANGE_ROADMAP',
    VIEW_MODULE: 'VIEW_MODULE',
    // Org-admin panel. Paired with the ORG_ADMIN_* entries in the server's admin audit trail
    // (services/org-admin-audit.js): these record who looked, that one records what changed.
    ORG_ADMIN_VIEW: 'ORG_ADMIN_VIEW',
    ORG_ADMIN_USER_CREATE: 'ORG_ADMIN_USER_CREATE',
    ORG_ADMIN_USER_UPDATE: 'ORG_ADMIN_USER_UPDATE',
    ORG_ADMIN_USER_IMPORT: 'ORG_ADMIN_USER_IMPORT',
    ORG_ADMIN_ROADMAP_UPDATE: 'ORG_ADMIN_ROADMAP_UPDATE',
    ORG_ADMIN_ACCESS_UPDATE: 'ORG_ADMIN_ACCESS_UPDATE',
})

export type ActionType = (typeof ACTIONS)[keyof typeof ACTIONS]
